export default __webpack_public_path__ + "assets/images/259b14118dadaaf6ecbe3b31c017b652.png";